enum Role {
	user,
	admin,
	owner
}

export default Role;